<div id="admin-main">
    <app-header></app-header>
    <app-sidebar [isExpanded]="sidebarExpanded" (toggleSidebar)="sidebarExpanded = !sidebarExpanded"></app-sidebar>
    <div class="content" [ngClass]="{ 'sidebarExpanded': sidebarExpanded }">
    </div>
    <router-outlet></router-outlet>
</div>
